import { Demographics } from '../../api/models';

export const AreDemographicsChanged = (
  oldDemographics: Demographics,
  newDemographics: Demographics
): boolean => {
  return (
    oldDemographics.firstName !== newDemographics.firstName ||
    oldDemographics.lastName !== newDemographics.lastName ||
    oldDemographics.middleName !== newDemographics.middleName ||
    oldDemographics.nameSuffix !== newDemographics.nameSuffix ||
    oldDemographics.dateOfBirth !== newDemographics.dateOfBirth ||
    oldDemographics.preferredSex !== newDemographics.preferredSex
  );
};

export const AreDemographicsValid = (demographics: Demographics): boolean => {
  return (
    demographics.firstName !== '' &&
    demographics.lastName !== '' &&
    (demographics.dateOfBirth ? true : false) &&
    demographics.preferredSex !== '' &&
    true
  );
};
